import '@theme/dialog';

// Server-side Shopify GET forms own filtering, sorting and URL history.
// The existing shell owns modal exclusivity and scroll locking.
class FDDiscoveryControls extends HTMLElement {
  async connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    const host = this.querySelector('[data-filter-host]');
    const panel = host?.querySelector('dialog');
    const trigger = this.querySelector('[data-filter-open]');
    if (!host || !panel || !trigger) return;
    await Promise.all([customElements.whenDefined('fd-header'), customElements.whenDefined('dialog-component')]);
    if (!this.isConnected || signal.aborted) return;
    const shell = document.querySelector('fd-header');
    await shell?.ready;
    if (!this.isConnected || signal.aborted) return;
    this.shell = shell;
    this.host = host;
    this.name = this.dataset.overlayName;
    shell?.adapt(this.name, host, 'showDialog', 'closeDialog', 'dialog');
    trigger.addEventListener('click', () => host.showDialog(), { signal });
    this.querySelector('[data-filter-close]').addEventListener('click', () => host.closeDialog(), { signal });
    host.addEventListener('dialog:open', () => trigger.setAttribute('aria-expanded', 'true'), { signal });
    host.addEventListener('dialog:close', () => trigger.setAttribute('aria-expanded', 'false'), { signal });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...panel.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled)')].filter(x => x.getClientRects().length);
      if (event.shiftKey && document.activeElement === controls[0]) { event.preventDefault(); controls.at(-1)?.focus(); }
      else if (!event.shiftKey && document.activeElement === controls.at(-1)) { event.preventDefault(); controls[0]?.focus(); }
    }, { signal });
  }
  disconnectedCallback() {
    this.abort?.abort();
    const shell = this.shell, name = this.name;
    const record = shell?.records.get(name);
    if (record?.host === this.host) {
      const release = () => { record.restore?.(); if (shell.records.get(name) === record) shell.records.delete(name); };
      if (record.panel.open) shell.close(name, false).finally(release);
      else release();
    }
  }
}
if (!customElements.get('fd-discovery-controls')) customElements.define('fd-discovery-controls', FDDiscoveryControls);
